import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=6af8c89d&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=6af8c89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8c89d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af8c89d')) {
      api.createRecord('6af8c89d', component.options)
    } else {
      api.reload('6af8c89d', component.options)
    }
    module.hot.accept("./GeneralInfo.vue?vue&type=template&id=6af8c89d&scoped=true&", function () {
      api.rerender('6af8c89d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/GeneralInfo.vue"
export default component.exports